export default class EnvironmentHelper {
    static readonly isProd = () => {
        return import.meta.env.VITE_ENV && import.meta.env.VITE_ENV === 'production';
    };
}
